import HomeIcon from "@mui/icons-material/Home";
import SportsScoreIcon from "@mui/icons-material/SportsScore";
import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import { HHNTheme } from "hhn-commons";
import React from "react";

export type ROUTE_ENDPOINT = "start" | "end";

// The Pin centres a text glyph on its line box, but an MUI icon is an inline
// SVG sitting on the text baseline, which leaves it riding high in the pin
// head. Drop it out of the baseline and nudge it onto the circle's centre.
const glyphStyle = {
  display: "block",
  transform: "translateY(2px)",
};

function LocationAddressMarker(props: {
  location: google.maps.places.PlaceResult;
  endpoint: ROUTE_ENDPOINT;
}) {
  const position =
    props.location.geometry && props.location.geometry.location
      ? props.location.geometry.location.toJSON()
      : undefined;
  const isStart = props.endpoint === "start";
  return (
    <AdvancedMarker
      position={position}
      title={props.location.formatted_address}
    >
      <Pin
        background={isStart ? HHNTheme.route.start : HHNTheme.route.end}
        borderColor={HHNTheme.common.white}
        glyphColor={HHNTheme.common.white}
      >
        {isStart ? (
          <HomeIcon fontSize="small" sx={glyphStyle} />
        ) : (
          <SportsScoreIcon fontSize="small" sx={glyphStyle} />
        )}
      </Pin>
    </AdvancedMarker>
  );
}

export default LocationAddressMarker;
